'use strict';

exports.__esModule = true;
exports.onRequestError = exports.onRequestEnd = exports.onRequestStart = exports.checkFields = exports.setCookies = exports.Promise = exports.passSU = exports.setMaxRequests = exports.setBaseURL = exports.releaseQueue = exports.addToQueue = exports.fetch = undefined;

var _odin_request = require('./odin_request.js');

var _request = require('./request.js');

var _utilsPromise = require('@chegg/ereader-core/dist/utils.Promise.js');

var _allowed_fields = require('../allowed_fields.json');

var _allowed_fields2 = _interopRequireDefault(_allowed_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var args_queue = [];
var cb_queue = [];
var max_requests = 10;
var check_fields = true;

function checkFields(flag) {
    check_feilds = flag;
}

function toArray(arr) {
    return arr instanceof Array ? arr : [arr];
}

function splitRequests(reqs, cb, use_zid) {
    var results = [],
        counter = 0,
        stopped = void 0;

    var _loop = function _loop(i, req) {
        _addToQueue(req, function (data) {
            if (stopped) return;
            results[i] = data;
            if (++counter == reqs.length) {
                cb(results);
            }
        }, use_zid);
    };

    for (var i = 0, req; req = reqs[i]; i++) {
        _loop(i, req);
    }

    releaseQueue();

    return function stop() {
        stopped = true;
        results = null;
        reqs = null;
        cb = null;
    };
}

function _fetch(requests, cb, user_id, error) {
    requests = toArray(requests);

    if (requests.length > max_requests) {
        return splitRequests.apply(undefined, arguments);
    }

    return (0, _odin_request.fetchRequest)({
        requests: requests,
        success: cb,
        error: error,
        user_id: user_id
    });
}

function _addToQueue(args, cb, use_zid) {
    var queue, i;

    for (i = 0; queue = args_queue[i]; i++) {
        if (queue.length < max_requests) break;
    }

    if (!queue || queue.length == max_requests) {
        args_queue[i] = [];
        cb_queue[i] = [];
    }

    args_queue[i].push(args);
    cb_queue[i].push(cb);

    if (use_zid) {
        args_queue[i].use_zid = use_zid;
    }
}

function releaseQueue() {
    var args = args_queue.shift(),
        cbs = cb_queue.shift();

    if (!args) return;

    _fetch(args, function (data) {
        var i, result;
        for (i = 0; result = data[i]; i++) {
            try {
                cbs[i](result);
            } catch (e) {}
        }

        if (args_queue.length) {
            releaseQueue();
        }
    }, args.use_zid);
}

function setMaxRequests(int) {
    max_requests = int;
}

var Promise = {
    releaseQueue: releaseQueue,
    setBaseURL: _odin_request.setBaseURL,
    setMaxRequests: setMaxRequests,
    passSU: _odin_request.passSU,
    fetch: function fetch(config, user_id) {
        var $p = new _utilsPromise.Promise();

        function done(res) {
            if (check_fields) {
                res.forEach(function (r) {
                    Object.keys(r).forEach(function (field) {
                        if (_allowed_fields2.default.indexOf(field) == -1) {
                            console.warn('OdinConcat response contains unsafe field - ' + field);
                        }
                    });
                });
            }

            $p.resolve(res);
        }

        try {
            $p.stop = _fetch(config, done, user_id, $p.reject);
        } catch (e) {
            $p.reject(e);
        }

        return $p;
    },
    fetchWithPaging: function fetchWithPaging(configs) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        return Promise.fetch.apply(Promise, [configs].concat(args)).then(function (res) {
            var stack = void 0;

            return fetchNext(getNextConfig(res));

            function getNextConfig(res) {
                stack = [];

                res.forEach(function (response, i) {
                    if (response.nextPage) {
                        var config = configs[i];
                        config.url = response.nextPage;
                        config.index = response.index != null ? response.index : i;
                        stack.push(config);
                    }
                });
            }

            function fetchNext(configs) {
                if (!configs.length) {
                    return res;
                }

                return Promise.fetch.apply(Promise, [configs].concat(args)).then(function (responses) {
                    responses.forEach(function (r, i) {
                        var conf = stack[i];
                        res[conf.index].concat(r.result || []);
                        r.index = conf.index;
                    });

                    return fetchNext(getNextConfig(responses));
                });
            }
        });
    },
    addToQueue: function addToQueue(config, use_zid) {
        var $p = new _utilsPromise.Promise();

        $p.stop = _addToQueue(config, $p.resolve, use_zid);
    }
};

exports.fetch = _fetch;
exports.addToQueue = _addToQueue;
exports.releaseQueue = releaseQueue;
exports.setBaseURL = _odin_request.setBaseURL;
exports.setMaxRequests = setMaxRequests;
exports.passSU = _odin_request.passSU;
exports.Promise = Promise;
exports.setCookies = _request.setCookies;
exports.checkFields = checkFields;
exports.onRequestStart = _request.onRequestStart;
exports.onRequestEnd = _request.onRequestEnd;
exports.onRequestError = _request.onRequestError;


//////////////////
// WEBPACK FOOTER
// ./~/@chegg/odin-concat/dist/batcher.js
// module id = 509
// module chunks = 0